import * as React from 'react'
import { useTransitionPage } from '@/utils/hooks/useTransitionPage'
import { Seo } from '@/components/util/entrypoint'
import { BaseTemplate } from '@/components/templates/baseTemplate'
import { Company } from '@/components/entrypoint'
import * as style from './index.module.css'

/**
 * @file 会社概要
 */
const Index = () => {
  const { transitionPage } = useTransitionPage()
  transitionPage()

  return (
    <BaseTemplate title="Company" description="会社概要">
      <div className={style.root}>
        <Company />
      </div>
    </BaseTemplate>
  )
}

export const Head = () => (
  <Seo
    title={`会社概要`}
    description="株式会社SOZOの会社概要を紹介いたします。"
  />
)
export default Index
